<section class="content">
  <div class="row homepage">
    <div class="col-lg-12 col-xs-12">
      <div class="message" *ngIf="error==='internalServerError'" > {{ 'genericErrorMessages.internalServerError' | translate }}</div>
      <div class="message" *ngIf="error==='badRequest'" > {{ 'genericErrorMessages.badRequest' | translate }}</div>
      <div class="message" *ngIf="error=='unAuthorized'" > {{ 'genericErrorMessages.unAuthorized' | translate }}</div>
      <div class="message" *ngIf="error=='requestTimeOut'" > {{ 'genericErrorMessages.requestTimeOut' | translate }}</div>
      <div class="lottie">
        <img src="../../../../assets/images/lottie-image.png"/>
      </div>
    </div>
  </div>
</section>